import React from "react";
import TreeNode from "./TreeNode";

export interface TreeNodeData {
  id: string | number;
  label: string;
  children?: TreeNodeData[];
  data?: unknown;
}

export interface TreeViewProps<T extends TreeNodeData = TreeNodeData> {
  nodes: T[];
  selectedId?: string | number;
  expandedIds?: Set<string | number>;
  onSelect?: (_node: T) => void;
  onToggleExpand?: (_nodeId: string | number) => void;
  renderNode?: (_node: T, _level: number) => React.ReactNode;
  className?: string;
  showConnectors?: boolean;
}

function TreeView<T extends TreeNodeData = TreeNodeData>({
  nodes,
  selectedId,
  expandedIds = new Set(),
  onSelect,
  onToggleExpand,
  renderNode,
  className = "",
  showConnectors = true,
}: TreeViewProps<T>) {
  return (
    <div className={`tree-view ${className}`} role="tree" aria-label="Tree navigation">
      {nodes.map((node) => (
        <TreeNode
          key={node.id}
          node={node}
          level={0}
          selectedId={selectedId}
          expandedIds={expandedIds}
          onSelect={onSelect}
          onToggleExpand={onToggleExpand}
          renderNode={renderNode}
          showConnectors={showConnectors}
        />
      ))}
    </div>
  );
}

export default TreeView;
